import { createFileRoute } from '@tanstack/react-router';

import { TeamPageContent } from '~/components/team/TeamPageContent';
import { DEFAULT_LOCALE } from '~/utils/i18n';

const TeamPage = () => {
  return <TeamPageContent />;
};

export const Route = createFileRoute('/$locale/team')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: TeamPage,
});
